// config.js
export const API_BASE_URL = 'https://backend.reportingbot.in/api';
export const API_BASE_URL_DICOM = 'https://backend.reportingbot.in';
// New centralized chat API URL
export const API_CHAT_URL = `${API_BASE_URL}/chat`;

// Functions using the centralized URL
export const getActiveRoom = (role) =>
  fetch(`${API_CHAT_URL}/active-room/?role=${role}`, { credentials: "include" })
    .then(res => res.json());

export const getAllRooms = () =>
  fetch(`${API_CHAT_URL}/rooms/`, { credentials: "include" })
    .then(res => res.json());

export const closeRoom = (roomId) =>
  fetch(`${API_CHAT_URL}/rooms/${roomId}/close/`, {
    method: "POST",
    credentials: "include",
  });

// Api/apiconnector.js

export const getWsUrl = (roomId) => {
  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  return `${protocol}://backend.reportingbot.in/ws/chat/${roomId}/`;
};
